import { Component } from '@angular/core';
import { DeliverableAnalyticsContentDirective } from '../../deliverable-analytics-content.directive';
import { SocialPostDetailsComponent } from '../social-post-details/social-post-details.component';

@Component({
  imports: [SocialPostDetailsComponent],
  selector: 'app-youtube-short-details',
  templateUrl: './youtube-short-details.component.html',
})
export class YoutubeShortDetailsComponent extends DeliverableAnalyticsContentDirective {}
